
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sc-hIPkLu sZNIM",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 6.164V13h-2V6.164L8.5 8.253 7.183 6.747l4.158-3.5a1 1 0 011.318 0l4.158 3.5L15.5 8.253 13 6.164zM16 18v-7h2v8a1 1 0 01-1 1H7a1 1 0 01-1-1v-8h2v7h8z","fill":"#2196F3"}})])
          )
        }
      }
    